import { render, staticRenderFns } from "./PlayerRank.vue?vue&type=template&id=63cabc39&lang=pug"
import script from "./PlayerRank.vue?vue&type=script&lang=js"
export * from "./PlayerRank.vue?vue&type=script&lang=js"
import style0 from "./PlayerRank.vue?vue&type=style&index=0&id=63cabc39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports